module.exports = __webpack_public_path__ + "h5/img/logo3332.e978e6b5.png";